<app-model-pj [downloadOnly]=true fxFlex="100"></app-model-pj>
